import { ArrowOutwardOutlined } from '@mui/icons-material';
import { Box, Card, Typography } from '@mui/material';

import { useStyles } from './documents-stats-card.styles';

type DocumentsStatsCardProps = {
  title: string;
  value: number;
  onClick: () => void;
};

export const DocumentsStatsCard = ({ title, value, onClick }: DocumentsStatsCardProps) => {
  const classes = useStyles();

  return (
    <Card className={classes.container} onClick={onClick}>
      <Box className={classes.headerContainer}>
        <Box className={classes.headerText}>{value} documents</Box>
        <ArrowOutwardOutlined />
      </Box>
      <Typography className={classes.title}>{title}</Typography>
    </Card>
  );
};
